<template>
  <div>
    <ul class="menu-nav">
      <li
        v-if="authorize == 'supplier'"
        aria-haspopup="true"
        data-menu-toggle="click"
        class="menu-item menu-item-submenu menu-item-open-dropdown"
      >
        <a href="#" class="menu-link menu-toggle">
          <span class="menu-text">
            کسب و کار:
            <span class="menu-text__merchant" v-if="currentMerchantObject">
              &nbsp;{{ currentMerchantObject.name }}</span
            >
            <span class="menu-text__merchant" v-else> انتخاب کنید </span>

            <span class="svg-icon menu-icon mr-1 mt-1">
              <inline-svg
                class="dropdown-arrow svg-icon"
                src="/media/svg/icons/Navigation/Angle-down.svg"
              />
            </span>
          </span>
        </a>
        <div
          class="menu-submenu menu-submenu-fixed"
          v-if="!$vuetify.breakpoint.smAndDown"
        >
          <div class="menu-subnav megamenu">
            <ul class="menu-content">
              <li class="menu-item">
                <h4 class="menu-heading menu-toggle">
                  <i class="menu-bullet menu-bullet-dot"><span></span></i>
                  <span class="menu-text"> کسب و کارها </span>
                  <i class="menu-arrow"></i>
                </h4>
                  <v-text-field
                    dense
                    label="جستجو"
                    v-model="merchantSearch"
                    outlined
                  
            ></v-text-field>
             
                <ul class="menu-inner">
                  <li
                    v-for="(item, index) in filterCurrentMerchantItems"
                    :key="index"
                    aria-haspopup="true"
                    class="menu-item"
                    :class="[
                      currentMerchantObject &&
                        currentMerchantObject.name === item.name &&
                        'menu-item-active',
                    ]"
                  >
                    <a @click="selectMerchant(item)" class="menu-link">
                      <span
                        class="svg-icon svg-icon-md menu-icon"
                        v-if="
                          currentMerchantObject &&
                          currentMerchantObject.name === item.name
                        "
                      >
                        <inline-svg
                          class="svg-icon"
                          src="/media/svg/icons/Navigation/Check.svg"
                        />
                      </span>
                      <i class="menu-bullet menu-bullet-dot mr-2" v-else
                        ><span></span
                      ></i>
                      <span class="menu-text"> {{ item.name }} </span>
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <div class="menu-submenu menu-submenu-fixed responsive-menu" v-else>
          <div class="menu-subnav megamenu">
            <ul class="menu-content">
              <li
                v-for="(item, index) in currentMerchantItems"
                :key="index"
                aria-haspopup="true"
                class="menu-item menu-inner"
                :class="[
                  currentMerchantObject &&
                    currentMerchantObject.name === item.name &&
                    'menu-item-active',
                ]"
              >
                <a @click="selectMerchant(item)" class="menu-link">
                  <span
                    class="svg-icon svg-icon-md menu-icon"
                    v-if="
                      currentMerchantObject &&
                      currentMerchantObject.name === item.name
                    "
                  >
                    <inline-svg
                      class="svg-icon"
                      src="/media/svg/icons/Navigation/Check.svg"
                    />
                  </span>
                  <i class="menu-bullet menu-bullet-dot mr-2" v-else
                    ><span></span
                  ></i>
                  <span class="menu-text"> {{ item.name }} </span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </li>
      <li v-if="currentMerchantObject" class="menu-item">
        <a
          @click.prevent="
            $router.push({ path: '/merchant-companies/add' }).catch(() => {})
          "
          class="menu-link menu-toggle"
        >
          <span class="menu-text">
            <i class="fas fa-plus"></i>
            <span v-if="$vuetify.breakpoint.smAndDown"> کسب و کار جدید </span>
          </span>
        </a>
      </li>
      <li class="menu-item">
        <a
          @click.prevent="
            $router.push({ path: '/merchant-messages' }).catch(() => {})
          "
          class="menu-link menu-toggle"
        >
          <span class="menu-text">
            پیام های شما
            <div v-if="unreadeMessageCount > 0">
              <v-badge
                color="primary"
                :content="unreadeMessageCount > 0 ? unreadeMessageCount : ''"
                inline
              ></v-badge>
            </div>
          </span>
        </a>
      </li>
      <!------------------------------------------------- Malihe ---------------------------------------------->
   
      <li
        v-if="unseenUserNotificationList"
        aria-haspopup="true"
        data-menu-toggle="click"
        class="menu-item menu-item-submenu menu-item-open-dropdown"
      >
        <a class="menu-link menu-toggle" ref="menutoggle">
          <span class="menu-text">
            <i class="mdi mdi-message"></i>
            {{ '  ' + messageCount + '  ' }}
            <span v-if="$vuetify.breakpoint.smAndDown">
              اعلان خوانده نشده
            </span>
          </span>
        </a>
        <div
          class="menu-submenu menu-submenu-fixed"
          v-if="!$vuetify.breakpoint.smAndDown"
        >
          <div class="menu-subnav megamenu" style="max-width:650px;">
            <ul class="menu-content">
              <li class="menu-item">
                <v-toolbar flat color="primary" dark>
                  <v-toolbar-title
                    >{{ messageCount }} اعلان خوانده نشده</v-toolbar-title
                  >
                  <v-divider></v-divider>
                  <v-btn  class="ml-5"  small  color="primary"  @click="$refs.menutoggle.click()">
                    <v-icon>mid mdi-close</v-icon>
                  </v-btn>
                </v-toolbar>
                <!-- <h4 class="menu-heading menu-toggle">
                  <i class="menu-bullet menu-bullet-dot"><span></span></i>
                  <span class="menu-text"> اعلان های خوانده نشده </span>
                  <i class="menu-arrow"></i>
                </h4> -->
                <ul class="menu-inner">
                  <li
                    v-for="(item, index) in unseenUserNotificationList"
                    :key="index"
                    aria-haspopup="true"
                    class="menu-item"
                  >
                    <a
                      @click="selectMessageToView(item, index)"
                      class="menu-link"
                    >
                      <v-row class="mr-2">
                        <v-col cols="12" md="2">
                          <v-img
                            v-if="item.badgeFile"
                            :src="
                              item.badgeFile && item.badgeFile.thumbnailFileUrl
                                ? item.badgeFile.thumbnailFileUrl
                                : ''
                            "
                            width="30"
                            height="30"
                          ></v-img>
                        </v-col>
                        
                          <v-col cols="12" md="10">
                            <strong class="menu-title">
                              {{ item.title }}
                            </strong>
                          </br>
                            <span class="float-left grey--text">{{
                              item.relativeTime
                            }}</span>
                           
                          
                            <span class="menu-text text-wrap">
                              {{ item.body }}
                            </span>
                          </v-col>
                         
                      </v-row>
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
            <v-btn
              small
              color="primary"
              @click="getAllNotification"
              class="btn-see-all"
              >مشاهده همه</v-btn
            >
          </div>
        </div>
        <div class="menu-submenu menu-submenu-fixed responsive-menu" v-else>
          <div class="menu-subnav megamenu">
            <v-btn
              small
              color="primary"
              @click="getAllNotification"
              class="btn-see-all"
              >مشاهده همه</v-btn
            >

            <ul class="menu-content">
              <li
                v-for="(item, index) in unseenUserNotificationList"
                :key="index"
                aria-haspopup="true"
                class="menu-item"
              >
                <a @click="selectMessageToView(item, index)" class="menu-link">
                  <v-row class="mr-2">
                    <v-col cols="2">
                      <v-img
                        v-if="item.badgeFile"
                        :src="
                          item.badgeFile && item.badgeFile.thumbnailFileUrl
                            ? item.badgeFile.thumbnailFileUrl
                            : ''
                        "
                        width="30"
                        height="30"
                      ></v-img>
                    </v-col>
                    <v-col cols="10">
                      <v-col cols="12">
                        <strong class="menu-title"> {{ item.title }} </strong>

                        <span class="float-left grey--text">{{
                          item.relativeTime
                        }}</span>
                      </v-col>
                      <v-col cols="12">
                        <span class="menu-text">
                          {{
                            item.body && item.body.length > 30
                              ? item.body.slice(0, 30) + '...'
                              : item.body
                          }}
                        </span>
                      </v-col>
                    </v-col>
                  </v-row>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </li>
    <li class="menu-item">
        <a
          @click.prevent="
            $router.push({ path: '/financial-management/wallet' }).catch(() => {})
          "
          class="menu-link menu-toggle"
        >
          <span class="menu-text">
            اعتبار   شما
            <div >
              <v-badge
                color="primary"
                :content="$store.getters.userWalletCredit | priceSplitter"
                inline
              ></v-badge>
              ریال
            </div>
          </span>
        </a>
      </li>
      <!-------------------------------------------------------------------------->
    </ul>
    <v-checkbox v-if="check"></v-checkbox>
    <audio src="/media/alert/success.mp3" id="audio"></audio>
    <v-dialog v-model="allNotification" width="800px">
      <v-card>
        <v-card-title>
          لیست تمام اعلان ها
          <v-spacer />
          <v-btn icon @click="allNotification = false" color="error"
            ><v-icon>mdi mdi-close</v-icon></v-btn
          >
        </v-card-title>
        <v-divider />
        <v-card-text>
          <v-sheet outlined>
            <v-data-table
              :items="allUserNotificationList"
              :headers="allUserNotificationHeader"
              disable-pagination
              hide-default-footer
            >
              <template v-slot:[`item.notificationType`]="{ item }">
                {{ notificationTypeDisplayName(item.notificationType) }}
              </template>
              <template v-slot:[`item.body`]="{ item }">
                <a
                  @click="selectMessageToView(item, item.index)"
                  target="_blank"
                >
                  {{
                   
                    item.body
                  }}
                </a>
              </template>
              <template v-slot:[`item.title`]="{ item }">
                <a
                  @click="selectMessageToView(item, item.index)"
                  target="_blank"
                >
                  {{ item.title ? item.title : '' }}
                </a>
              </template>
              <template v-slot:[`item.link`]="item">
                <a
                  @click="selectMessageToView(item.item, item.index)"
                  target="_blank"
                >
                  ارجاع
                </a>
              </template>
              <template v-slot:[`item.seen`]="{ item }">
                {{ item.seen ? 'خوانده شده' : 'خوانده نشده' }}
              </template>
            </v-data-table></v-sheet
          >
          <div class="text-center pt-5">
            <v-row>
              <v-col cols="12" sm="2" md="2">
                <v-select
                  outlined
                  dense
                  v-model="notificationItemsPerPage"
                  :items="[5, 10, 20]"
                  label="تعداد نمایش در صفحه"
                ></v-select>
              </v-col>

              <v-col cols="12" sm="10" md="10">
                <v-pagination
                  circle
                  v-model="notificationPageNumber"
                  :length="notificationPageCount ? notificationPageCount : 1"
                  :total-visible="7"
                ></v-pagination>
              </v-col>
            </v-row>
          </div>
        </v-card-text>
        <v-card-actions></v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-if="authorize == 'supplier'"
      v-model="chooseMerchantDialog"
      persistent
      max-width="500px"
    >
      <v-toolbar>انتخاب کسب و کار</v-toolbar>
      <v-card class="pt-5">
        <v-card-text>
          <v-form ref="merchantChack">
            <v-select
              placeholder="کسب و کار ها"
              label="لطفا ابتدا یک کسب و کار را انتخاب کنید."
              required
              :items="currentMerchantItems"
              outlined
              dense
              item-text="name"
              item-value="merchantId"
              return-object
              v-model="merchant"
            ></v-select>
          </v-form>
        </v-card-text>
        <v-card-actions class="d-flex justify-end">
          <v-btn
            color="blue"
            dark
            :disabled="!merchant"
            @click="selectMerchant(merchant)"
            >تایید</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { RepoFactory } from '@/baseRepository/Factory';
import KTSearchDefault from '@/view/layout/extras/dropdown/SearchDefault.vue';
import i18nService from '@/core/services/i18n.service.js';
import Helper from '../../../core/helpers';
import Swal from 'sweetalert2';
const enumsRepository = () => RepoFactory.get('enums');
const supplierRepository = () => RepoFactory.get('supplier');
const subscriptionRepository = () => RepoFactory.get('subscription');
const notificationRepository = () => RepoFactory.get('notification');
import { mapActions, mapGetters } from 'vuex';
import asyncLoadMixin from '@/core/mixins/asyncLoadMixin';
import reusableMethodsMixin from '@/core/mixins/reusableMethodsMixin';

export default {
  name: 'KTMenu',
  mixins: [asyncLoadMixin, reusableMethodsMixin],

  data() {
    return {
      allUserNotificationHeader: [
        {
          value: 'badgeFilePicture',
          text: 'تصویر',
          sortable: true,
        },
        {
          value: 'title',
          text: 'عنوان ',
          sortable: true,
        },
        {
          value: 'body',
          text: 'متن ',
          sortable: true,
        },
        {
          value: 'seen',
          text: 'خوانده شده ',
          sortable: true,
        },
        //  {
        //   value: 'link',
        //   text: 'لینک ',
        //   sortable: true,
        // },
        //  {
        //   value: 'notificationType',
        //   text: 'نوع اعلان ',
        //   sortable: true,
        // },
        {
          value: 'relativeTime',
          text: 'تاریخ ',
          sortable: true,
        },
      ],
      allNotification: false,
      notificationPageNumber: 1,
      notificationPageCount: 1,
      notificationItemsPerPage: 7,
      allUserNotificationList: [],
      check: false,
      connection: '',
      unseenUserNotificationList: [],
      messageCount: 0,
      languageFlag: '',
      languages: i18nService.languages,
      currentMerchantItems: [],
      currentMerchantObject: null,
      merchant: null,
      chooseMerchantDialog: false,
      notificationTypeList: [],
      startTimeForSignalRHub: 100,
      merchantSearch: "",
      filterCurrentMerchantItems: [],
    };
  },
  created() {
    this.$store.dispatch(
      'getUnreadTreadeConversation',
      this.$store.getters.currentMerchant
    );
    this.check = true;
    this.check = false;
    this.getNotificationType();
    if (
      this.oidcAccessToken &&
      this.userDetails &&
      (this.$store.getters.authorize == 'supplier' ||
        this.$store.getters.authorize == 'merchant')
    ) {
      this.getMemebershipPlantsAvailability();
      this.getunseenUserNotification();
      // -------------------------------------------------------//
      this.connection = new this.$signalR.HubConnectionBuilder()
        .withUrl(`${this.notificationBaseUrl}/hub/notification`, {
          accessTokenFactory: () =>
            localStorage.getItem('taksan_supplier_access_token'),
        })
        .withAutomaticReconnect()
        .configureLogging(this.$signalR.LogLevel.Information)
        .build();
      this.connection.onclose(async () => {
        await this.start();
      });
      this.start();
      // -------------------------------------------------------///
    }
    if (
      this.oidcAccessToken &&
      this.userDetails &&
      this.userDetails.roles.includes('supplier')
    ) {
      this.currentMerchantItemsFunction();
    } else if (
      this.oidcAccessToken &&
      this.userDetails &&
      !this.userDetails.roles.includes('supplier') &&
      this.userDetails.roles.includes('merchant')
    ) {
    }
  },
  components: {
    KTSearchDefault,
  },
  computed: {
    ...mapGetters('oidc', ['oidcAccessToken', 'oidcUser']),
    ...mapGetters([
      'userDetails',
      'authorize',
      'unreadeMessageCount',
      'currentMerchant',
    ]),
    currentMerchantTitle() {
      return this.currentMerchantObject
        ? this.currentMerchantObject.name
        : 'یک شرکت انتخاب کنید';
    },
    LOCAL_STORAGE_KEY() {
      return 'currentMerchantObject_' + this.oidcUser.phone_number;
    },
    notificationBaseUrl() {
      return this.$store.getters.notificationBaseUrl;
    },
    subscriptionBaseUrl() {
      return this.$store.getters.subscriptionBaseUrl;
    },
    MerchantId() {
      return this.$store.getters.currentMerchant;
    },
    supplierTrialDays() {
      return this.$store.getters.SupplierPanelTrailDays;
    },
  },
  watch: {
    notificationPageNumber(after, before) {
      if (after) {
        this.getAllNotification();
      }
    },
    notificationItemsPerPage(after, before) {
      this.notificationPageNumber = 1;
      if (after) {
        this.getAllNotification();
      }
    },
    oidcAccessToken(after) {
      if (
        after &&
        this.userDetails &&
        this.userDetails.roles.includes('supplier')
      ) {
        this.currentMerchantItemsFunction();
      } else if (
        this.oidcAccessToken &&
        this.userDetails &&
        !this.userDetails.roles.includes('supplier') &&
        this.userDetails.roles.includes('merchant')
      ) {
        // this.getcurrentmerchant();
      }
    },
    currentMerchant(after) {
      if (after) {
        this.$store.dispatch('getUnreadTreadeConversation', after);
      }
    },
    MerchantId(after) {
      if (after) {
        this.getMemebershipPlantsAvailability();
      }
    },
    merchantSearch(after) {
 
      this.filterCurrentMerchantItems = this.currentMerchantItems.filter((el) => el.name.includes(after))
       
    }
  },
  methods: {
    getMemebershipPlantsAvailability() {
      if (this.MerchantId) {
        const loader = this.$loading.show();
        subscriptionRepository()
          .getActiveSubscriptionPlans(this.subscriptionBaseUrl, {
            MerchantId: this.MerchantId,
          })
          .then((res) => {
            if (res.data) {
              this.$store.commit('setMembershipPlan', res.data);
              this.computeAvailabileTime();
            }
            loader.hide();
          })
          .catch((err) => {
            loader.hide();
          });
      }
    },
    computeAvailabileTime() {
      if (this.$store.getters.membershipPlan) {
        var now = new Date();
        var endDateUtc = new Date(
          this.$store.getters.membershipPlan.endDateUtc
        );
        let minimize = endDateUtc.getTime() - now.getTime();
        var Difference_In_Days = Math.ceil(minimize / (1000 * 3600 * 24));
        this.$store.commit('setAvailabileTime', Difference_In_Days);
      } else if (this.$store.getters.merchantInformation) {
        var now = new Date();
        var approvedTimeUtc = new Date(
          this.$store.getters.merchantInformation.approvedTimeUtc
        );
        const nowTime = now.getTime();
        const approvedTimeUtcTime = approvedTimeUtc.getTime();
        let minimize = nowTime - approvedTimeUtcTime;
        var DaysPassFromApprove = Math.ceil(minimize / (1000 * 3600 * 24));
        if (DaysPassFromApprove < this.supplierTrialDays) {
          this.$store.commit(
            'setAvailabileTrialTime',
            this.supplierTrialDays - DaysPassFromApprove
          );
        }
      }
    },
    // computeAvailabileTime() {
    //   if (this.$store.getters.membershipPlan) {
    //     var now = new Date();
    //     var endDateUtc = new Date(
    //       this.$store.getters.membershipPlan.endDateUtc
    //     );
    //     let minimize = now.getTime() - endDateUtc.getTime();
    //     var Difference_In_Days = Math.ceil(minimize / (1000 * 3600 * 24));
    //     this.$store.commit(
    //       'setAvailabileTime',
    //       this.$store.getters.SupplierPanelTrailDays - Difference_In_Days
    //     );
    //   } else if (this.$store.getters.merchantInformation) {
    //     var now = new Date();
    //     var approvedTimeUtc = new Date(
    //       this.$store.getters.merchantInformation.approvedTimeUtc
    //     );
    //     let minimize = now.getTime() - approvedTimeUtc.getTime();
    //     var Difference_In_Days = Math.ceil(minimize / (1000 * 3600 * 24));

    //     this.$store.commit(
    //       'setAvailabileTime',
    //       this.$store.getters.SupplierPanelTrailDays - Difference_In_Days
    //     );
    //   }
    // },
    // getMembershipPlanById(id) {
    //   const loader = this.$loading.show();
    //   subscriptionRepository()
    //     .getMembershipPlanById(id, this.subscriptionBaseUrl)
    //     .then((res) => {

    //       this.$store.commit('setMembershipPlan', res.data);
    //       this.computeAvailabileTime();
    //       loader.hide();
    //     })
    //     .catch((err) => {
    //       loader.hide();
    //     });
    // },
    getNotificationType() {
      enumsRepository()
        .getEnum('NotifyType', this.notificationBaseUrl)
        .then((res) => {
          this.notificationTypeList = res.data;
        })
        .catch((err) => Helper.handleErrors(err, this));
    },
    notificationTypeDisplayName(title) {
      if (this.notificationTypeList.length) {
        let result = this.notificationTypeList.find((el) => el.title == title);
        if (result) return result.displayName;
      }
    },
    selectMessageToView(item, index) {
      notificationRepository()
        .seenUserNotification(
          this.notificationBaseUrl,
          {},
          { notificationId: String(item.notifyId) }
        )
        .then((res) => {
          if (this.allNotification) {
            this.allNotification = false;
            if (!item.seen) {
              this.messageCount = this.messageCount - 1;
            }
          } else {
            this.unseenUserNotificationList.splice(index, 1);
            this.messageCount = this.unseenUserNotificationList.length;
          }
          if(item.link.length>20)  window.open(item.link);
        })
        .catch((err) => {});
    },
    async start() {
      try {
        await this.connection.start();
        console.log('SignalR Connected.');
        this.getunseenUserNotificationRealTime();
      } catch (err) {
        this.startTimeForSignalRHub =
          this.startTimeForSignalRHub * Math.log(this.startTimeForSignalRHub);
        setTimeout(() => {
          this.start();
        }, this.startTimeForSignalRHub);
      }
    },
    getunseenUserNotificationRealTime() {
      this.connection.on('RecieveNotification', (message) => {
        notificationRepository()
          .recieveUserNotification(
            this.notificationBaseUrl,
            {},
            { notificationId: String(message.id) }
          )
          .then((res) => {
            message.notifyId = message.id;
            this.unseenUserNotificationList.reverse();
            this.unseenUserNotificationList.push(message);
            this.unseenUserNotificationList.reverse();
            this.messageCount = this.unseenUserNotificationList.length;
            this.$dialog.message.success('شما یک اعلان جدید دارید', {
              position: 'top-left',
            });
            let audio = document.getElementById('audio');
            // audio.autoplay = true
            // audio.muted = 'muted'
            audio.play();
          })
          .catch((err) => {});
      });
    },
    getunseenUserNotification() {
      notificationRepository()
        .getunseenUserNotification(this.notificationBaseUrl)
        .then((res) => {
          this.unseenUserNotificationList = res.data;
          this.messageCount = res.data.length;
        })
        .catch();
    },
    getAllNotification() {
      let params = {
        PageNumber: this.notificationPageNumber,
        ItemsPerPage: this.notificationItemsPerPage,
      };
      const loader = this.$loading.show();
      notificationRepository()
        .getUserNotification(this.notificationBaseUrl, {}, params)
        .then((res) => {
          this.allUserNotificationList = res.data.list;
          console.log("allUserNotificationList")
           console.log(this.allUserNotificationList)
          this.notificationPageCount = Math.ceil(
            res.data.totalCount / this.notificationItemsPerPage
          );
          this.allNotification = true;
          loader.hide();
        })
        .catch((err) => {
          loader.hide();
        });
    },
    ...mapActions('oidc', ['signOutOidcSilent']),

    hasActiveChildren(match) {
      return this.$route['path'].indexOf(match) !== -1;
    },
    currentMerchantItemsFunction() {
      this.$store
        .dispatch('getCurrentMechantsItems')
        .then((body) => {
          this.currentMerchantItems = body;
          this.filterCurrentMerchantItems = body;

          if (
            this.userDetails.roles.includes('supplier') &&
            this.currentMerchantItems.length == 0
          ) {
            return Swal.fire({
              text: 'هیچ کسب و کاری برای شما ثبت نشده است لطفا دوباره وارد شوید!',
              icon: 'error',
              confirmButtonText: 'خروج',
              allowOutsideClick: () => {
                return false;
              },
              reverseButtons: true,
            }).then((result) => {
              if (result.isConfirmed) {
                this.signOutOidcSilent();
              }
            });
          }
          if (
            localStorage.getItem(this.LOCAL_STORAGE_KEY) &&
            this.currentMerchantItems.length > 1
          ) {
            let currentMerchantTemp = JSON.parse(
              localStorage.getItem(this.LOCAL_STORAGE_KEY)
            );

            this.currentMerchantItems.forEach((element) => {
              if (element.merchantId == currentMerchantTemp.merchantId) {
                this.currentMerchantObject = element;
              }
            });
            this.$store.commit(
              'setCurrentMerchantObject',
              this.currentMerchantObject
            );
            this.$store.commit(
              'setCurrentMerchant',
              this.currentMerchantObject.merchantId
            );
            this.$store.commit(
              'setMerchantIsManufacturer',
              this.currentMerchantObject.isManufacturer
            );
            localStorage.setItem(
              this.LOCAL_STORAGE_KEY,
              JSON.stringify(this.currentMerchantObject)
            );
          } else if (this.currentMerchantItems.length == 1) {
            this.currentMerchantObject = this.currentMerchantItems[0];
            this.$store.commit(
              'setCurrentMerchantObject',
              this.currentMerchantObject
            );
            this.$store.commit(
              'setCurrentMerchant',
              this.currentMerchantObject.merchantId
            );
            this.$store.commit(
              'setMerchantIsManufacturer',
              this.currentMerchantObject.isManufacturer
            );
          } else {
            this.chooseMerchantDialog = true;
          }
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        });
    },
    selectMerchant(item) {
      this.currentMerchantObject = item;
      this.$store.commit(
        'setCurrentMerchant',
        this.currentMerchantObject.merchantId
      );
      this.$store.commit(
        'setCurrentMerchantObject',
        this.currentMerchantObject
      );
      this.$store.commit(
        'setMerchantIsManufacturer',
        this.currentMerchantObject.isManufacturer
      );
      localStorage.setItem(
        this.LOCAL_STORAGE_KEY,
        JSON.stringify(this.currentMerchantObject)
      );
      window.location.href = '/dashboard';
    },
    getAccountingSettingByMerchantId() {
      this.$store.commit('setAccountingSettingByMerchantId', null);
      this.$store.commit('setAllAccountingSettings', []);
      this.$store.commit('setAccountingSetting', null);
      this.$store
        .dispatch('getAccountingSettingByMerchantId')
        .then((body) => {})
        .catch((error) => {
          if (error.response.status == 404) {
            Swal.fire({
              text: 'هیچ تنظیماتی برای شما ثبت نشده است با مراجعه به بخش تنظیمات لطفا تنظیمات مورد نظر خود را ثبت نمایید',
              icon: 'error',
              confirmButtonText: 'رفتن به بخش تنظیمات',
              reverseButtons: true,
            }).then((result) => {
              if (result.isConfirmed) {
                this.$router.push({
                  path: '/setting',
                });
                let sendObj = {
                  to: '/setting',
                  name: 'تنظیمات حسابداری',
                };
                this.$store.dispatch('addTab', sendObj);
              }
            });
          } else if (error.response.status == 422) {
            this.$router.push({
              path: '/setting',
            });
            let sendObj = {
              to: '/setting',
              name: 'تنظیمات حسابداری',
            };
            this.$store.dispatch('addTab', sendObj);
          } else {
            Helper.handleErrors(error, this);
          }
        });
    },
    // ----------------------Malihe ---------------------//
    getcurrentmerchant() {
      const loader = this.$loading.show();
      supplierRepository()
        .getSupplierByUser(this.$store.getters.merchantBaseUrl)
        .then((res) => {
          let currentMerchant = res.data;
          this.$store.commit(
            'setMerchantIsManufacturer',
            currentMerchant.isManufacturer
          );
          this.$store.commit('setCurrentMerchant', currentMerchant.merchantId);
          this.$store.commit('setCurrentMerchantObject', currentMerchant);
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
        })
        .finally(() => loader.hide());
    },
  },
};
</script>
<style scoped>
.dropdown-arrow.svg-icon {
  height: 1.2rem;
  width: 1.2rem;
}
.primary-scrollbar::-webkit-scrollbar {
  display: block;
  width: 6px !important;
  height: 6px !important;
}
.primary-scrollbar::-webkit-scrollbar-track {
  background: transparent;
}

.primary-scrollbar::-webkit-scrollbar-thumb {
  border-radius: 10px;
  height: 3px !important;
  width: 3px !important;
  margin-top: 0.3rem;
  background: -webkit-linear-gradient(rgb(255, 175, 138), rgb(245, 168, 105));
}

.primary-scrollbar::-webkit-scrollbar-track-piece:end {
  background: transparent;
  margin-bottom: 10px;
}

.primary-scrollbar::-webkit-scrollbar-track-piece:start {
  background: transparent;
  margin-top: 10px;
}
.scroll-y {
  overflow-y: scroll;
}
.max-h-200 {
  max-height: 200px;
}
@media (min-width: 992px) {
  .header-menu .menu-nav > .menu-item {
    position: relative;
  }
  .header-menu .menu-nav > .menu-item .menu-text__merchant {
    display: inline-block;
    margin-right: 0.3rem;
  }
  .header-menu .menu-nav > .menu-item .menu-submenu {
    min-width: 500px;
    width: max-content;
  }

  .header-menu
    .menu-nav
    > .menu-item
    .menu-submenu
    > .menu-subnav
    .menu-content
    .menu-inner {
    padding: 0 0 20px;
    max-height: 200px;
    overflow: scroll;
    margin-bottom: 0rem;
    /* width: max-content; */
  }
}
@media (max-width: 991.98px) {
  .header-menu-mobile
    .menu-nav
    > .menu-item
    > .menu-submenu
    .menu-subnav
    .menu-content
    .menu-inner {
    max-height: 300px;
    overflow: scroll;
  }
}
.responsive-menu {
  max-height: 100vh;
  overflow: scroll;
}
.btn-see-all {
  margin: 0 auto;
  margin-bottom: 10px;
  margin-right: 40%;
}
</style>
